import React from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  TableCell,
  TableRow,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

interface PlanCreateFormProps {
  newPlan: any;
  planStatusOptions: any[];
  templates: any[];
  editingPlanId: number | null;
  loading: boolean;
  onNewPlanChange: (vehiclemodelid: number, field: string, value: string) => void;
  onAddPlan: (vehiclemodelid: number) => void;
  section: number;
}

const PlanCreateForm: React.FC<PlanCreateFormProps> = ({
  newPlan,
  planStatusOptions,
  templates,
  editingPlanId,
  loading,
  onNewPlanChange,
  onAddPlan,
  section,
}) => {
  return (
     <TableRow sx={{
       backgroundColor: "rgba(248, 249, 250, 0.8)",
       borderTop: "2px solid rgba(13,44,90,0.1)",
       "& .MuiTableCell-root": {
         padding: "8px 12px",
         borderBottom: "none",
         verticalAlign: "middle",
         textAlign: "center"
       }
     }}>
        <TableCell sx={{ textAlign: "center", width: "12%" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            value={newPlan.planName}
            onChange={(e) =>
              onNewPlanChange(section as number, "planName", e.target.value)
            }
            placeholder="Plan Name"
            disabled={editingPlanId !== null}
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "12px",
                "& .MuiOutlinedInput-input": {
                  fontSize: "13px",
                },
              },
            }}
          />
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "10%" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            value={newPlan.duration}
            onChange={(e) =>
              onNewPlanChange(section as number, "duration", e.target.value)
            }
            placeholder="Duration (Days)"
            disabled={editingPlanId !== null}
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
                "& .MuiOutlinedInput-input": {
                  fontSize: "13px",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "&[type=number]": {
                    MozAppearance: "textfield",
                  },
                },
              },
            }}
          />
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "9%" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            value={newPlan.kmLimit}
            onChange={(e) =>
              onNewPlanChange(section as number, "kmLimit", e.target.value)
            }
            placeholder="KM Limit"
            disabled={editingPlanId !== null}
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
                "& .MuiOutlinedInput-input": {
                  fontSize: "13px",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "&[type=number]": {
                    MozAppearance: "textfield",
                  },
                },
              },
            }}
          />
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "10%" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            value={newPlan.price}
            onChange={(e) =>
              onNewPlanChange(section as number, "price", e.target.value)
            }
            placeholder="Price"
            disabled={editingPlanId !== null}
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
                "& .MuiOutlinedInput-input": {
                  fontSize: "13px",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "&[type=number]": {
                    MozAppearance: "textfield",
                  },
                },
              },
            }}
          />
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "12%" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            value={newPlan.processing_fees || ""}
            onChange={(e) =>
              onNewPlanChange(section as number, "processing_fees", e.target.value)
            }
            placeholder="Processing Fees"
            disabled={editingPlanId !== null}
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
                "& .MuiOutlinedInput-input": {
                  fontSize: "13px",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "&[type=number]": {
                    MozAppearance: "textfield",
                  },
                },
              },
            }}
          />
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "13%" }}>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            type="number"
            value={newPlan.refundable_amount || ""}
            onChange={(e) =>
              onNewPlanChange(section as number, "refundable_amount", e.target.value)
            }
            placeholder="Refundable Amount"
            disabled={editingPlanId !== null}
            autoComplete="off"
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: "13px",
                "& .MuiOutlinedInput-input": {
                  fontSize: "13px",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "&[type=number]": {
                    MozAppearance: "textfield",
                  },
                },
              },
            }}
          />
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "12%" }}>
          <FormControl
            fullWidth
            size="small"
             sx={{
               "& .MuiOutlinedInput-root": {
                 fontSize: "13px",
                 "& .MuiOutlinedInput-input": {
                   fontSize: "11px",
                 },
               },
               "& .MuiInputLabel-root": {
                 fontSize: "13px",
               },
               "& .MuiInputLabel-asterisk": {
                 color: "red !important",
               },
             }}
          >
            <InputLabel
              sx={{
                fontSize: "13px",
                "&.MuiInputLabel-asterisk": {
                  color: "red !important",
                },
                "& .MuiInputLabel-asterisk": {
                  color: "red !important",
                },
              }}
            >
              Template
            </InputLabel>
            <Select
              value={newPlan.template}
              onChange={(e) =>
                onNewPlanChange(section as number, "template", e.target.value)
              }
              label="Template"
              disabled={editingPlanId !== null}
              sx={{
                fontSize: "11px",
                "& .MuiSelect-select": {
                  fontSize: "13px",
                },
              }}
            >
              <MenuItem value="" disabled>
                (Select Template)
              </MenuItem>
              {templates && templates.length > 0
                ? templates.map((template) => (
                    <MenuItem
                      key={template.ratetemplatemasterid}
                      value={template.ratetemplatemasterid}
                    >
                      {template.templatename}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "10%" }}>
          <FormControl
            fullWidth
            size="small"
             sx={{
               "& .MuiOutlinedInput-root": {
                 fontSize: "11px",
                 "& .MuiOutlinedInput-input": {
                   fontSize: "13px",
                 },
               },
               "& .MuiInputLabel-root": {
                 fontSize: "13px",
               },
               "& .MuiInputLabel-asterisk": {
                 color: "red !important",
               },
             }}
          >
            <InputLabel
              sx={{
                fontSize: "13px",
                "&.MuiInputLabel-asterisk": {
                  color: "red !important",
                },
                "& .MuiInputLabel-asterisk": {
                  color: "red !important",
                },
              }}
            >
              Status
            </InputLabel>
            <Select
              value={newPlan.status}
              onChange={(e) =>
                onNewPlanChange(section as number, "status", e.target.value)
              }
              label="Status"
              disabled={editingPlanId !== null}
              sx={{
                fontSize: "13px",
                "& .MuiSelect-select": {
                  fontSize: "13px",
                },
              }}
            >
              {planStatusOptions.map((statusOption) => (
                <MenuItem
                  key={statusOption.codevalue}
                  value={statusOption.codedisplayname}
                >
                  {statusOption.codedisplayname}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell sx={{ textAlign: "center", width: "10%" }}>
          <FormControl
            fullWidth
            size="small"
             sx={{
               "& .MuiOutlinedInput-root": {
                 fontSize: "13px",
                 "& .MuiOutlinedInput-input": {
                   fontSize: "11px",
                 },
               },
               "& .MuiInputLabel-root": {
                 fontSize: "11px",
               },
               "& .MuiInputLabel-asterisk": {
                 color: "red !important",
               },
             }}
          >
            <InputLabel
              sx={{
                fontSize: "13px",
                "&.MuiInputLabel-asterisk": {
                  color: "red !important",
                },
                "& .MuiInputLabel-asterisk": {
                  color: "red !important",
                },
              }}
            >
              Popular
            </InputLabel>
            <Select
              value={newPlan.popular}
              onChange={(e) =>
                onNewPlanChange(section as number, "popular", e.target.value)
              }
              label="Popular"
              disabled={editingPlanId !== null}
              sx={{
                fontSize: "13px",
                "& .MuiSelect-select": {
                  fontSize: "13px",
                  textAlign: "center",
                },
              }}
            >
              <MenuItem value="True">True</MenuItem>
              <MenuItem value="False">False</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell></TableCell>
      </TableRow>
  );
};

export default PlanCreateForm;
